export const isArray = prop =>
	Object.prototype.toString.call(prop) === '[object Array]'
export const isObject = prop =>
	Object.prototype.toString.call(prop) === '[object Object]'
export const isString = prop =>
	Object.prototype.toString.call(prop) === '[object String]'
export const isNumber = prop =>
	Object.prototype.toString.call(prop) === '[object Number]'
export const isFunction = prop =>
	Object.prototype.toString.call(prop) === '[object Function]'
export const isBoolean = prop =>
	Object.prototype.toString.call(prop) === '[object Boolean]'
export const isDate = prop =>
	Object.prototype.toString.call(prop) === '[object Date]'
export const isDom = prop => prop instanceof HTMLElement
